// extracted by mini-css-extract-plugin
export default {"component":"Footer_component__nbKbS","dark":"Footer_dark__jxmfl"};